module.exports = __webpack_public_path__ + "static/media/globe-icon.225173a0.webp";